import { VerificationStatus } from '../Types/General';
import { Rating, Talent } from '../Types/Talent';

export const getHasRequiredFields = (talent: Talent) => {
  if (
    typeof talent?.resume?.summary != undefined &&
    talent?.resume?.languages?.length > 0 &&
    typeof talent?.resume?.expertise != undefined &&
    talent?.resume?.education?.length > 0 &&
    talent?.resume?.experience?.length > 0 &&
    talent?.verification_status === VerificationStatus.verified
  ) {
    return true;
  }

  return false;
};

export const getPercentageText = (itemValue: number, total: number): string => {
  if (total === 0 || isNaN(itemValue) || isNaN(total)) {
    return '0%';
  }
  const percentage = (itemValue / total) * 100;
  return `${Math.round(percentage)}%`;
};

export const isTalent = (item: any): item is Talent => {
  return (
    item &&
    typeof item.locator === 'string' &&
    item.locator.toUpperCase().startsWith('TLT'))
};

export const calculateAverageScore = (
  scores: Record<string, number>,
): number => {
  if (!scores || Object.keys(scores).length === 0) {
    return 0;
  }

  // Calculate the average score (if valid scores exist)
  // A score is only valid if it is greater than 0
  const validScores = Object.values(scores).filter(score => score > 0); // Include only non-zero values
  if (validScores.length === 0) {
    return 0;
  }

  const total = validScores.reduce(
    (accumulatedValues, score) => accumulatedValues + score,
    0,
  );
  return parseFloat((total / validScores.length).toFixed(1));
};

export const calculateAverageScoreAndReviews = (
  talentData: Talent,
): {
  averageScore: number;
  noOfRatings: number;
  nonEmptyFeedbackRatings: Array<Rating>;
} => {
  // Destructure the ratings object from talentData
  const { ratings } = talentData || {};

  // Get the average scores from the ratings
  const averageScores = ratings?.averageScores;

  // Calculate the average score (if valid scores exist)
  // A score is only valid if it is greater than 0
  const averageScore = calculateAverageScore(averageScores || {});

  // Get the total number of ratings from the history array
  const noOfRatings = ratings?.history?.length || 0;

  // Count the comments with non-empty feedback
  const nonEmptyFeedbackRatings = getNonEmptyFeedbackRatings(
    ratings?.history || [],
  );

  return { averageScore, noOfRatings, nonEmptyFeedbackRatings };
};

export const getNonEmptyFeedbackRatings = (
  ratingsHistory: Rating[],
): Rating[] => {
  return ratingsHistory.filter(
    rating =>
      rating.feedback !== undefined &&
      rating.feedback !== null &&
      rating.feedback.trim() !== '',

  );
};
